<script lang="ts">
  import type { Snippet } from 'svelte';

  interface Props {
    as?: 'a' | 'button';
    to?: string | null;
    rel?: string | null;
    onclick?: () => void;
    children?: Snippet;
  }

  let { as = 'a', to = null, rel = null, onclick, children }: Props = $props();
</script>

<!-- svelte-ignore a11y_no_static_element_interactions -->
<svelte:element this={as} class="link" href={to} {rel} {onclick}>
  {@render children?.()}
</svelte:element>

<style lang="scss">
  .link {
    color: var(--twist-color-gray-0);
    font-family: var(--font-family-primary);
    font-size: var(--twist-font-size-0);
    font-weight: 700;
    line-height: 1.6;
    box-shadow: none;
    text-decoration: none;
    outline: 2px solid transparent;
    outline-offset: 2px;
    position: relative;
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;

    &::before {
      content: '';
      transform-origin: 100% 50%;
      transform: scale3d(0, 1, 1);
      transition: transform 0.2s ease-out;
      position: absolute;
      width: 100%;
      height: 2px;
      background: var(--twist-color-gray-0);
      top: 100%;
      left: 0px;
      pointer-events: none;
    }

    &:hover,
    &:global(.focus-visible) {
      &::before {
        transform-origin: 0% 50%;
        transform: scale3d(1, 1, 1);
      }
    }
  }
</style>
